// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".applicationDiv[data-v-04c21dd5],.titleDiv[data-v-04c21dd5]{padding-top:10px}h1[data-v-04c21dd5]{margin-top:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
